<template>
  <div class="navuser">
    <el-dropdown @command="handleCommand" class="user">
      <span class="el-dropdown-link">
        <i class="fas fa-user"></i> {{partnerUser.name}}
      </span>
      <el-dropdown-menu slot="dropdown" trigger="click">
        <el-dropdown-item command="resetpassword">Reset password</el-dropdown-item>
        <el-dropdown-item command="logout">Logout</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
     <el-dialog width="30%" vtitle="Edit Point" :visible.sync="showResetPasswordForm">
    <!-- <b-modal
      id="reset-password"
      title="Reset password"
      hide-footer
    > -->
      <resetpassword></resetpassword>
    <!-- </b-modal> -->
     </el-dialog>
  </div>

</template>

<script>
import { mapState, mapActions } from "vuex";
import resetpassword from './ResetPassword'

export default {
  name: 'nav-user',
  components: { resetpassword },
  data () {
    return {
      showResetPasswordForm:false
    }
  },
  computed: {
    ...mapState("account", ["partnerUser"])
  },
  methods: {
    handleCommand (command) {
      switch (command) {
        case 'logout':
           this.logout()
          break
        case 'resetpassword': 
        this.showResetPasswordForm =true
          break
      }
    },
     ...mapActions("account", ["login", "logout"]),
  }
}
</script>

<style scoped>
.navuser{
  color:white;
  display: flex;
  margin-left: auto;
 order:2;
}
.user{
  margin-right:30px;
  float:right
}
.el-dropdown-link {
  cursor: pointer;
  color: white;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
